import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/components/dialogue/radix-dialog";
import { Member } from "src/redux/types/_customer.type";
import EditMemberForm from "./edit-member-form";

const EditMemberDialog = ({
  member,
  children,
}: {
  member: Member;
  children: React.ReactNode;
}) => {
  return (
    <Dialog>
      <DialogTrigger>{children}</DialogTrigger>
      <DialogContent className="bg-white min-w-5xl max-w-5xl">
        <DialogHeader>
          <DialogTitle className="text-center">
            Edit {member.first_name} {member.last_name}
          </DialogTitle>
        </DialogHeader>
        <EditMemberForm member={member} />
      </DialogContent>
    </Dialog>
  );
};

export default EditMemberDialog;
